import { CanAccess, useTranslate } from "ra-core";
import { Navigate } from "react-router";
import { useIsMobile } from "@/hooks/use-mobile";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { MobileBackButton } from "../misc/MobileBackButton";
import { ProfileOptionList } from "../profileOptions/ProfileOptionList";

/**
 * Almikia Epic EC2d (TASK-138): the Direccion-only "Tipos de propiedad" admin. It reuses the
 * generic catalogue list of "Opciones del perfil" (`ProfileOptionList`: add, rename, archive,
 * reactivate; nothing is deleted) on the `property_types` resource, whose FakeRest callbacks
 * and SQL guard own the label rules. A custom route mounted in both shells (`CRM.tsx`) and
 * reached from Settings; other roles are sent home.
 */
export const PropertyTypesPage = () => (
  <CanAccess
    resource="property_types"
    action="edit"
    accessDenied={<Navigate to="/" replace />}
  >
    <PropertyTypesPageContent />
  </CanAccess>
);

PropertyTypesPage.path = "/property_types";

const PropertyTypesPageContent = () => {
  const translate = useTranslate();
  const isMobile = useIsMobile();
  const title = translate("crm.propertyTypes.page_title");

  const body = (
    <ProfileOptionList
      resource="property_types"
      titleKey="crm.propertyTypes.list_title"
    />
  );

  if (isMobile) {
    return (
      <>
        <MobileHeader>
          <MobileBackButton to="/settings" />
          <div className="flex flex-1 min-w-0">
            <h1 className="text-xl font-semibold truncate">{title}</h1>
          </div>
        </MobileHeader>
        <MobileContent>{body}</MobileContent>
      </>
    );
  }

  return (
    <div className="mx-auto max-w-2xl p-4 pb-8">
      <h1 className="text-2xl font-semibold mb-4">{title}</h1>
      {body}
    </div>
  );
};
